import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	UnorderedList,
	ListItem,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl =
	"https://www.linkedin.com/in/jyotsna-krishnan-3b44997/?originalSubdomain=in";

const FundInFocusOct: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund in Focus: A Deep Dive into Elevar Equity&apos;s 15+ Year Journey
					of Impactful Investments
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href={linkedInUrl}
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Jyotsna Krishnan
					</Link>
					, Managing Partner,{" "}
					<Link
						href="https://elevarequity.com/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Elevar Equity
					</Link>
					. In this feature, Jyotsna throws light on how Elevar works with
					passionate founders to build enduring, impactful companies.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7113422258879525971.jpg"
				alt="Jyotsna Krishnan"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="cover"
				rounded="full"
			/>
			<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
				<Heading
					textAlign={{ xs: "center", md: "left" }}
					fontWeight="800"
					color="blue.400"
				>
					Spokesperson: Jyotsna Krishnan, Managing Partner, Elevar Equity
				</Heading>
				<Flex
					columnGap={{ xs: "4px", md: "16px" }}
					justifyContent={{ xs: "center", md: "flex-start" }}
					transform={{ xs: "translateX(12px)", md: "none" }}
				>
					<Box alignSelf="center">
						<Link href={linkedInUrl} target="_blank">
							<IconButton
								aria-label="linkedin"
								icon={
									<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
								}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Box>
				</Flex>
			</Flex>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. How would you describe your investment philosophy and approach to
						sustainable growth?
					</Heading>
					<Text variant="blogAnswer">
						Elevar Equity’s investment strategy is about backing seasoned
						business leaders that have turned entrepreneurial to build out
						commercial business models that deliver high quality and affordable
						essential services to underserved communities across India and Latin
						America. Essential services tend to include education, agriculture,
						MSME services, financial services, housing and healthcare - all
						areas of high priority for discerning households with increasing
						purchasing power, aspiring for growth and seeking higher quality
						services.
						<br />
						<br />
						We are normally the first institutional investor in our portfolio
						companies. Our role as an early investor has been an important one
						in helping founders build organizational DNA that stays true to
						commercial discipline as well as remain ‘customer centric’ in the
						long run.
						<br />
						<br />
						Thus far, in our 15+ year journey, we have raised 5 funds,
						democratized essential services for over 50 million households, and
						catalyzed billions of dollars of capital into 47 companies.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2. What sets Elevar Equity apart from other private equity firms in
						terms of its investment strategy and focus?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We are fairly unique in our customer centric thesis and concentrated
						early-growth stage strategy:
					</Text>
					<UnorderedList>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								We firmly believe in taking a bottom up approach to developing
								our investment thesis. We spend considerable time with
								underserved customers on the field to develop a deep
								understanding of their aspirations, priorities, cash flows and
								challenges, and translate these insights into our investment
								strategy
							</Text>
						</ListItem>
						{/* 2nditem */}
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								Given our conviction and understanding of our markets, we are
								able to invest early - often as day zero investors - and yet
								build a concentrated portfolio (translating to 2-3 new
								investments a year) with a low loss ratio. We tend to double
								down on fewer companies and are disciplined in how we approach
								matters of P&L and governance. We do this in order to lay down
								the foundation for long term scale, very early in the journey
							</Text>
						</ListItem>
						{/* 3rditem */}
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								We are also clear that we invest only in business models where
								impact is at the core, with high impact leading to high returns.
								For Elevar, impact is not a metric to be measured ‘on the side’,
								but it should be measurable through thoughtful business metrics
							</Text>
						</ListItem>
					</UnorderedList>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. How does Elevar Equity prioritize environmental, social, and
						governance (ESG) factors in its investment decisions?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Since our investment thesis is premised on breaking barriers of
						access and inequity for underserved customers, ESG has always been
						at the core of how we invest. As early stage investors in emerging
						markets’ companies, we recognize the role we play in providing
						entrepreneurs and businesses the right insights, frameworks, and
						guidance to build long-term sustainability and impact.
						<br />
						<br />
						We believe that implementing ESG requires an authentic approach that
						is reflective of the company’s business model, industry and stage of
						maturity / evolution. Our ESG approach takes this into account, with
						interventions designed for each stage of the company’s growth
						lifecycle. Check out our recent{" "}
						<Link
							color="secondaryPurple.600"
							href="https://docsend.com/view/kmqfcrknzjbm2vx6"
							target="_blank"
							rel="noopener noreferrer"
						>
							Impact Report
						</Link>{" "}
						(page 39 onwards) to learn more about how we engage with our
						portfolio to help think through their ESG approach.
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. Can you provide insights into the typical size of investments
						Elevar Equity makes and the geographic regions you primarily target?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						We are usually the first institutional investor in our companies and
						our check sizes range between $2Mn and $5Mn for seed to Series A
						round - we also like to reserve meaningfully for follow-on rounds.
						We currently target business models that are based in India and
						Latin America.
					</Text>
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. How does Elevar Equity support portfolio companies beyond
						financial investment? What resources or expertise do you offer to
						help them succeed?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Entrepreneurs like to tap into our deep experience of almost two
						decades in helping companies scale - this spans across multiple
						strategic aspects including:
					</Text>
					<UnorderedList>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Unit economics and P&L discipline:
								</Text>
								Scale creates impact, and scale requires capital and talent.
								Both capital and talent value wealth creation opportunities.
								Building an enduring organization requires discipline through
								the highs and lows of the market - and we help reinforce this
								discipline
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Organization building:
								</Text>
								Working with companies at every stage of their growth cycle to
								think through distribution economics, identifying product-market
								fit, senior team recruitment, building the organizational
								platform for scale and finally, achieving scale
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Governance:
								</Text>
								Ensuring best practices around governance and ESG standards -
								not just in form but in spirit. Laying these foundations early
								on has helped companies build well respected brands across
								stakeholders
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Calling it like it is:
								</Text>
								Honest feedback and perspective based on collective experience -
								this is hard to explain, but we have grown to appreciate how
								valuable this is to our entrepreneurs
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Customer and market insights:
								</Text>
								Our direct engagement with the customers our companies serve
								forms the basis for several critical strategic discussions that
								are differentiated
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Strategic resources:
								</Text>
								We offer our founders engagement with a select set of
								experienced advisors that are on board with us and deeply care
								about the success of our founders - these include experts on
								talent and HR, tech and data, former successful entrepreneurs
								and retail distribution experts
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Sounding board through a lonely journey:
								</Text>
								Being an entrepreneur is lonely - from challenging fundraising
								environments to building a team from scratch. Entrepreneurs tend
								to reach out to us and we proactively engage to de-risk the
								journey and keep the focus on the ambition to build scale for
								impact
							</Text>
						</ListItem>
					</UnorderedList>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. What key performance indicators (KPIs) do you consider most
						important when evaluating the success of an investment?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						As mentioned earlier, we believe in building enduring, customer
						centric organizations that can scale sustainably and impact millions
						of lives. We divide the company building process into three stages
						of growth, focusing on different KPIs at each stage to achieve the
						above goals.:
					</Text>
					<UnorderedList>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Distribution Economics:
								</Text>
								This stage is about validating the business model, establishing
								customer margins and demand. Hence positive distribution
								economics become important at this stage, along with ensuring
								that the business model’s DNA is centered around the needs of
								the underserved customer
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Organizational Platform:
								</Text>
								This stage is about establishing an organization platform for
								scale, and about ensuring that the business model creates
								genuine value for the customer, leading to customer loyalty and
								advocacy - a critical foundational step for sustainable scale
							</Text>
						</ListItem>
						<ListItem pb="14px">
							<Text variant="blogAnswer" pl={{ md: "12px", lg: "18px" }}>
								<Text as="span" variant="blogQuestion" fontWeight="700">
									Expansion:
								</Text>
								At this stage, scaling the organization becomes the key focus
								area, from both the impact (e.g. no. of underserved customers
								impacted) and returns dimension
							</Text>
						</ListItem>
					</UnorderedList>
					<Text variant="blogAnswer" py="16px">
						Ultimately, when a company is attractive, there is demand from
						investors (public or private) and exits follow course - we focus on
						building companies that reach scale and are attractive for incoming
						investors.
					</Text>
				</Box>
				{/* Question 7 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. How does Elevar Equity approach diversity and inclusion in both
						its investment strategy and within its own organization?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Elevar has a natural gender lens in the way it drives impact- our
						investment strategy focuses on solutions that empower underserved
						households and women throughout the business value chain.
						<br />
						<br />
						We have a majority of women in our leadership and team - 4 out of 6
						partners are female and ~60% employees are female. This has been
						core to our DNA - trying to bring about change in the world requires
						diversity of thinking, and gender diversity at senior levels is one
						form of diversity.
						<br />
						<br />
						To take a more explicit stance, we have also aligned our management
						and measurement with the 2X Challenge and Beyond the Billion
						initiatives (both initiatives were launched to drive more
						intentional gender diversity in the world of investing and
						entrepreneurship). Our most recent fund, Elevar Fund V, was deemed a
						&quot;Flagship Fund&quot; by the 2X Challenge Committee.
					</Text>
				</Box>

				{/* Question 8 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						8. Share some interesting work by a few of your portfolio companies
						in terms of market problems they are trying to solve and impact
						generated so far.
					</Heading>
					<>
						<Heading variant="blogQuestion" fontWeight="800" pt="16px">
							LEADERSHIP BOULEVARD
						</Heading>
						<Text variant="blogAnswer" pb="16px">
							Leadership Boulevard (LEAD) was founded with the vision to make
							excellent education accessible and affordable to children in
							underserved communities across India. LEAD’s ‘school-in-a-box’
							solution empowers affordable private school (APS - typically in an
							annual fee range of $150-700) operators in India and caters to the
							needs of largely first-generation learners in the low-income
							segment. LEAD’s integrated solution keeps the child’s learning
							outcomes as the focal point, while seamlessly addressing pain
							points across every stakeholder’s continuum, in school and at
							home.
							<br />
							<br />
							Collectively, the founders Sumeet and Smita bring over 40 years of
							experience, much of it in the education space. LEAD’s solutions
							are steeped in the learnings of the entrepreneurs, having
							personally run a few schools in remote areas for several years.
							<br />
							<br />
							LEAD supports 9000+ schools today and has reached 5 Mn+ students.
							The company has demonstrated strong student learning outcomes
							despite Covid related disruptions: with 1.6 years of measurable
							learning improvement in literacy and comprehension and over 77%
							mastery achieved in other subjects such as math, science and
							social studies.
							<br />
							<br />
							Earlier in 2023, LEAD completed its acquisition of the local K-12
							learning business of Pearson India. With this acquisition, LEAD
							now has the largest portfolio of school ed-tech products and
							services and aims to better serve the learning needs of the entire
							spectrum of over 500,000 private schools in India.
						</Text>
					</>
					<>
						<Heading variant="blogQuestion" fontWeight="800" pt="16px">
							SAMUNNATI
						</Heading>
						<Text variant="blogAnswer" pb="16px">
							Samunnati was founded with the vision to make markets work for
							smallholder farmers. The company is India’s largest ‘Open Agri
							Network’, unlocking commerce and finance across agricultural value
							chains and platforms. Samunnati offers a range of solutions that
							empower agri supply chain players like smallholder farmers, FPOs
							(Farmer Producer Organizations – membership based collective
							action groups of farmers), MSMEs in agri value chains and
							agricultural enterprises.
							<br />
							<br />
							Founder and CEO Anil Kumar SG has over three decades of experience
							in the banking and microfinance industry - most of it in rural
							India - and has a deeply nuanced understanding of the agri
							segment.
							<br />
							<br />
							Samunnati has deep presence across 5 key agri value chains spread
							over 22 states in India and has powered over $2Bn of gross
							transaction value in its journey so far. Samunnati currently has
							access to 5500+ Farmer Collectives with a member base of ~9
							million farmers and envisions impacting 1 in every 4 farming
							households through its network by 2027.
						</Text>
					</>
					<>
						<Heading variant="blogQuestion" fontWeight="800" pt="16px">
							CUREBAY
						</Heading>
						<Text variant="blogAnswer" pb="16px">
							CureBay aims to transform the patient experience in remote
							locations of India by providing affordable and high-quality
							primary healthcare through a hybrid model – a network of physical
							e-clinics, powered by a robust technology platform. Each e-clinic
							is in a location that has limited or no healthcare within a radius
							of 5 to 10 kms. It is staffed with a trained nurse and a qualified
							phlebotomist - mostly local talent known by those in the catchment
							area. These healthcare workers assist walk-in patients to connect
							them with city-based doctors via video consultations.
							CureBay&apos;s technology enables doctors to access detailed and
							personalized patient records, thus helping them to deliver a
							high-quality diagnosis, equivalent to a physical consultation.
							Patients also have access to a network of certified partner labs,
							hospitals for specialized treatment, and the option to get
							prescribed medicines delivered to them directly through the
							e-clinics.
							<br />
							<br />
							Founders Priyo, Shobhan and Sanjay and bring a wealth of
							complimentary experience across entrepreneurship, operations, and
							technology.
							<br />
							<br />
							In its 3 year journey, CureBay has already built 50 eClinics
							across 18 districts in Odisha, and impacted over 36,000 patients.
						</Text>
					</>
					<>
						<Heading variant="blogQuestion" fontWeight="800" pt="16px">
							NIRO
						</Heading>
						<Text variant="blogAnswer" pb="16px">
							Niro is an embedded consumer lending platform that aims to
							democratize access to financial products by leveraging the data
							and distribution of consumer internet companies. It enables these
							consumer internet companies to become consumer finance enablers
							and offer a holistic set of financial products to customers who
							are historically unserved / underserved by traditional sources of
							financing such as banks. Niro leverages its platform partners’
							brand & engagement to deliver embedded, frictionless and
							competitive products to their end consumers.
							<br />
							<br />
							Founders Aditya Kumar and Sankalp Mathur have significant
							complementary experience, bringing in a strong focus on risk and
							responsible lending supported by a strong, already built out team
							and extensive network across fintech & financial services.
							<br />
							<br />
							Within 20 months of operations, the company has demonstrated
							strong growth with INR 500 Cr in disbursals and strong strategic
							tie-ups that give it access to a base of more than 100Mn
							customers.
						</Text>
					</>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusOct;
